import React from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import "./BannerThatsit.css";
import Translate from "../../../../../../../translate";
import LogoThatsIt from "../../../../../img/ThatsIt_Logo.png";
import ThatsitBanner from "../../../../../img/Thatsit_new.png";
import ThatsitBannerEnglish from "../../../../../img/thats-it-new-english.svg";
import Cel from "../../../../../img/Celular_terminal.png";
import CelMobile from "../../../../../img/banner-cel-mobile.png";
import BasketMobile from "../../../../../img/banner-basket-mobile.png"

const BannerThatsit = ({lan}) => {
  return (
    <div className='comisiones-outter'>
      <div className="align-ilustration">
        <Image src={Cel} className="plant-that" />
        <Image src={lan === 'es' ? ThatsitBanner : ThatsitBannerEnglish} style={lan !== 'es' ? {top: '-80px'} : {}} className="banner-barista"/>
        <Image src={CelMobile} className="plant-that-cel"/>
      </div>
      <Container>
        <Row>
          <Col xl={6} lg={6} className="center-text-mobile">
            <p>
              <div className="title-align-mobile">
                <span className="title-mobile"><Image src={LogoThatsIt} width={120}/></span>
              </div>
              <span className="title">{Translate[lan].landing3.banner.thatsit.titulo}<Image src={LogoThatsIt} width={120}/>?</span>
              <br/>
              <span className='subtitle'>
                {Translate[lan].landing3.banner.thatsit.subtitulo}
              </span>
              <div className="basket-align-mobile">
                <span className="basket-mobile"><Image src={BasketMobile}/></span>
              </div>
            </p>
            <div className="align-btn">
              <Button className='that-btn' onClick={()=>window.open(window.location.origin + '/register','_blank')}>{Translate[lan].landing3.banner.button1}</Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default BannerThatsit